import React from 'react'

export default function CenteredTitleSection(props) {
  return (
    <section className='section-centered-title container'><h2 className='title'>{props.title}</h2></section>
  )
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/LandingPageBlocks/CenteredTitleSection.jsx